"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const filterText = ({ _eq, _like, _ilike }, text) => {
    if (_eq) {
        return ramda_1.equals(_eq, text);
    }
    if (_like) {
        return ramda_1.contains(_like, text);
    }
    if (_ilike) {
        return ramda_1.contains(ramda_1.toLower(_ilike), ramda_1.toLower(text));
    }
    return false;
};
exports.vlTextFilter = {
    name: "VLTextFilter",
    sdl: `
    input VLTextFilter {
      _eq: String
      _like: String
      _ilike: String
    }
  `,
    filterFunction: filterText,
};
exports.vlLongTextFilter = {
    name: "VLLongTextFilter",
    sdl: `
    input VLLongTextFilter {
      _eq: String
      _like: String
      _ilike: String
    }
  `,
    filterFunction: filterText,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dEZJbHRlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY21zL2ZpbHRlcnMvdGV4dEZJbHRlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBa0Q7QUFTbEQsTUFBTSxVQUFVLEdBQUcsQ0FBQyxFQUFFLEdBQUcsRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFnQixFQUFFLElBQVksRUFBRSxFQUFFO0lBQ3hFLElBQUksR0FBRyxFQUFFO1FBQ1AsT0FBTyxjQUFNLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFDO0tBQzFCO0lBQ0QsSUFBSSxLQUFLLEVBQUU7UUFDVCxPQUFPLGdCQUFRLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxDQUFDO0tBQzlCO0lBQ0QsSUFBSSxNQUFNLEVBQUU7UUFDVixPQUFPLGdCQUFRLENBQUMsZUFBTyxDQUFDLE1BQU0sQ0FBQyxFQUFFLGVBQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0tBQ2pEO0lBQ0QsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUM7QUFFVyxRQUFBLFlBQVksR0FBdUM7SUFDOUQsSUFBSSxFQUFFLGNBQWM7SUFDcEIsR0FBRyxFQUFFOzs7Ozs7R0FNSjtJQUNELGNBQWMsRUFBRSxVQUFVO0NBQzNCLENBQUM7QUFFVyxRQUFBLGdCQUFnQixHQUF1QztJQUNsRSxJQUFJLEVBQUUsa0JBQWtCO0lBQ3hCLEdBQUcsRUFBRTs7Ozs7O0dBTUo7SUFDRCxjQUFjLEVBQUUsVUFBVTtDQUMzQixDQUFDIn0=